import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, vShow as _vShow, unref as _unref, Transition as _Transition } from "vue";
const _hoisted_1 = { class: "container" };
const _hoisted_2 = { class: "title" };
const _hoisted_3 = { class: "container" };
const _hoisted_4 = { class: "wrapper" };
const _hoisted_5 = { class: "box metrics" };
const _hoisted_6 = { class: "list b-metrics" };
const _hoisted_7 = { class: "form-wrapper search-and-filter" };
const _hoisted_8 = ["placeholder"];
const _hoisted_9 = {
    key: 1,
    class: "icon icon-search"
};
const _hoisted_10 = {
    key: 0,
    class: "listBox customScrollBar"
};
const _hoisted_11 = {
    key: 0,
    class: "title"
};
const _hoisted_12 = { class: "items" };
const _hoisted_13 = { class: "label-container" };
const _hoisted_14 = ["onClick"];
const _hoisted_15 = ["innerHTML"];
const _hoisted_16 = { class: "box selected-items" };
const _hoisted_17 = { class: "selected-items-list" };
const _hoisted_18 = { class: "box selected-list ml-auto metrics customScrollBar" };
const _hoisted_19 = ["id"];
const _hoisted_20 = /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-hamburger" }, null, -1);
const _hoisted_21 = ["onClick"];
const _hoisted_22 = { class: "info-wrapper" };
const _hoisted_23 = { class: "info-text" };
const _hoisted_24 = { class: "button-wrapper" };
import { useStore } from 'vuex';
import { ref, computed } from 'vue';
import { stringParser } from '@/helpers/string-parser.js';
import { escapeRegExp } from 'lodash';
import { VueDraggableNext as draggable } from 'vue-draggable-next';
import { useToast } from 'vue-toastification';
import i18n from '@/i18n';
// components
import CheckBox from '@/components/_atoms/CheckBox.vue';
import BaseLoader from '@/components/_atoms/BaseLoaderSpinner.vue';
// utils
import { mapOrder } from '@/utilities/table/mapOrder';
import { useMixpanelUpdateColumns } from '@/utilities/mixpanel';
// types
import { SelectedPreset, DateDimensionKeys, StoreSellerPresets, SellerDayOffRelevantKeys, } from '@/features/EngagementReport/models';
export default /*#__PURE__*/ _defineComponent({
    __name: 'EditColumns',
    setup(__props) {
        // libs
        const store = useStore();
        const toast = useToast();
        // state
        const searchMetric = ref('');
        const error = ref(false);
        // action
        const deleteCheckedMetricsAndDimensions = (key) => store.dispatch('engagementReport/deleteCheckedMetricsAndDimensions', key);
        const setUpdateCheckedSelectedMetricsAndDimensions = (metric) => store.dispatch('engagementReport/setUpdateCheckedSelectedMetricsAndDimensions', metric);
        const updateCheckedMetricsAndDimensions = (key, type = '') => store.dispatch('engagementReport/updateCheckedMetricsAndDimensions', { key, type });
        const updateSelectedMetricsAndDimensions = (metric) => store.dispatch('engagementReport/updateSelectedMetricsAndDimensions', metric);
        const setEditColumnsIsVisible = (isVisible) => store.dispatch('engagementReport/setEditColumnsIsVisible', isVisible);
        const setResetToDefaultMetricsAndDimensions = () => store.dispatch('engagementReport/setResetToDefaultMetricsAndDimensions');
        // computed
        const getIsVisible = computed(() => store.getters['engagementReport/getIsEditColumnsVisible']);
        const getMetricsAndDimensions = computed(() => store.getters['engagementReport/getListOfMetricsAndDimensions']);
        const getSelectedMetricsAndDimensions = computed(() => store.getters['engagementReport/getSelectedMetricsAndDimensions']);
        const getMetricsAndDimensionsOrdering = computed(() => store.getters['engagementReport/getMetricsAndDimensionsOrdering']);
        const checkedMetricsAndDimensions = computed(() => store.getters['engagementReport/getCheckedMetricsAndDimensions']);
        const getIsEditColumnsLoading = computed(() => store.getters['engagementReport/getIsEditColumnsLoading']);
        const getFixedColumns = computed(() => store.getters['engagementReport/getFixedColumns']);
        const getPreset = computed(() => store.getters['engagementReport/getPreset']);
        // functions
        const handleSellerDayOffDimension = (key) => {
            const currentPreset = getPreset.value;
            const selectedDimensions = getSelectedMetricsAndDimensions.value;
            if (!StoreSellerPresets.has(currentPreset))
                return false;
            const isAmountSellerDayOffSelected = selectedDimensions.some(dimension => dimension.key === SellerDayOffRelevantKeys.AMOUNT_SELLER_DAY_OFF);
            const isAnyDateDimensionSelected = selectedDimensions.some(dimension => DateDimensionKeys.has(dimension.key));
            if (key === SellerDayOffRelevantKeys.AMOUNT_SELLER_DAY_OFF) {
                return isAnyDateDimensionSelected;
            }
            if (DateDimensionKeys.has(key)) {
                return isAmountSellerDayOffSelected;
            }
            return false;
        };
        const shouldBlockKeyDimensionsByPreset = (key) => {
            if (getPreset.value === SelectedPreset.DATE) {
                return shouldBlockMinimumOneDateDimension(key);
            }
            return getFixedColumns.value[getPreset.value]?.includes(key);
        };
        const shouldBlockMinimumOneDateDimension = (key) => {
            const keyDimensionsByDatePreset = getFixedColumns.value;
            const selectedDateDimensions = getSelectedMetricsAndDimensions.value.filter(dimension => keyDimensionsByDatePreset[getPreset.value].includes(dimension.key));
            const isDateDimension = keyDimensionsByDatePreset[getPreset.value].includes(key);
            return selectedDateDimensions.length === 1 && isDateDimension && selectedDateDimensions[0].key === key;
        };
        const closeEditTableModal = () => {
            setEditColumnsIsVisible(false);
        };
        const getListOfMetricsAndDimensions = (data, term) => {
            const applyParse = escapeRegExp(stringParser(term));
            return data.filter(table => new RegExp(applyParse, 'gi').test(stringParser(table.name)));
        };
        const getHighlightText = (text, highlight) => {
            const parsedText = stringParser(text);
            const parsedHighlight = stringParser(highlight);
            const pattern = new RegExp(escapeRegExp(parsedHighlight), 'gi');
            const match = pattern.exec(parsedText);
            if (match !== null) {
                const startIndex = match.index;
                const endIndex = startIndex + highlight.length;
                const slicedText = text.slice(startIndex, endIndex);
                const wrapHighlight = `<strong>${slicedText}</strong>`;
                return text.replace(slicedText, wrapHighlight);
            }
            return text;
        };
        const clearTerm = () => {
            searchMetric.value = '';
        };
        const isCheckedItems = (item) => {
            const filterMetricsKeys = getSelectedMetricsAndDimensions.value.map(item => item.key);
            return filterMetricsKeys.includes(item);
        };
        const checkItems = (item) => {
            if (getSelectedMetricsAndDimensions.value.map(item => item.key).includes(item.key))
                return deleteCheckedMetricsAndDimensions(item.key);
            setUpdateCheckedSelectedMetricsAndDimensions(item);
        };
        const hasItems = (data) => {
            const filteredList = getListOfMetricsAndDimensions(data, searchMetric.value);
            return filteredList.length > 0;
        };
        const getManualMetricOrder = () => {
            const keys = document.querySelectorAll('.selected-list.metrics .selected .selected-title');
            const attrs = [];
            keys.forEach(el => {
                const id = el.getAttribute('id');
                if (id !== null) {
                    attrs.push(id);
                }
            });
            return attrs.filter(Boolean);
        };
        const onDrop = (type) => {
            const newArr = getManualMetricOrder();
            if (type === 'metrics') {
                updateCheckedMetricsAndDimensions(newArr, 'draggable');
                updateSelectedMetricsAndDimensions(mapOrder(getSelectedMetricsAndDimensions.value, checkedMetricsAndDimensions.value, 'key'));
            }
        };
        const hasEmptyMetrics = () => {
            return !getSelectedMetricsAndDimensions.value?.length;
        };
        const resetToDefault = () => {
            setResetToDefaultMetricsAndDimensions();
            closeEditTableModal();
        };
        const submit = () => {
            if (hasEmptyMetrics()) {
                error.value = true;
                toast.error(i18n.global.t('dashboard.edit-columns.error'), {
                    timeout: 5000,
                });
                return;
            }
            const selectedMetricsAndDimensions = getSelectedMetricsAndDimensions.value.map(el => el.key);
            updateCheckedMetricsAndDimensions(selectedMetricsAndDimensions);
            useMixpanelUpdateColumns('view_oto_engagement_report_update-columns', selectedMetricsAndDimensions);
            error.value = false;
            closeEditTableModal();
        };
        return (_ctx, _cache) => {
            const _component_el_tooltip = _resolveComponent("el-tooltip");
            const _component_el_dialog = _resolveComponent("el-dialog");
            return (_openBlock(), _createBlock(_component_el_dialog, {
                modelValue: getIsVisible.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((getIsVisible).value = $event)),
                width: "800",
                id: "engagement-report-dialog-edit-columns",
                onClose: closeEditTableModal
            }, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t('dashboard.edit-columns.title')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("h4", null, _toDisplayString(_ctx.$tc('dashboard.edit-columns.metric-dimension')), 1),
                                _createElementVNode("div", _hoisted_6, [
                                    _createElementVNode("div", _hoisted_7, [
                                        _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((searchMetric).value = $event)),
                                            class: "findTerm",
                                            placeholder: _ctx.$tc('dashboard.edit-columns.search-metric-dimension')
                                        }, null, 8, _hoisted_8), [
                                            [_vModelText, searchMetric.value]
                                        ]),
                                        (searchMetric.value !== '')
                                            ? (_openBlock(), _createElementBlock("i", {
                                                key: 0,
                                                class: "icon icon-close",
                                                onClick: clearTerm
                                            }))
                                            : (_openBlock(), _createElementBlock("i", _hoisted_9))
                                    ]),
                                    (!getIsEditColumnsLoading.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getMetricsAndDimensions.value, (metric, key) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                    key: key,
                                                    class: "item"
                                                }, [
                                                    (hasItems(metric.data))
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.$tc(metric.key)), 1))
                                                        : _createCommentVNode("", true),
                                                    _createElementVNode("div", _hoisted_12, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getListOfMetricsAndDimensions(metric.data, searchMetric.value), (item, key) => {
                                                            return (_openBlock(), _createElementBlock("div", {
                                                                key: key,
                                                                class: "items-list"
                                                            }, [
                                                                _createVNode(_component_el_tooltip, {
                                                                    content: _ctx.$tc('campaign.engagement-report.edit-columns-key-tooltip'),
                                                                    placement: "right",
                                                                    trigger: "hover",
                                                                    disabled: !shouldBlockKeyDimensionsByPreset(item.key),
                                                                    "popper-class": "items-tooltip"
                                                                }, {
                                                                    default: _withCtx(() => [
                                                                        _createElementVNode("div", _hoisted_13, [
                                                                            _createElementVNode("label", {
                                                                                class: _normalizeClass([
                                                                                    'checkbox-label',
                                                                                    {
                                                                                        disabled: shouldBlockKeyDimensionsByPreset(item.key) || handleSellerDayOffDimension(item.key),
                                                                                    },
                                                                                ]),
                                                                                onClick: _withModifiers(($event) => (checkItems(item)), ["prevent"])
                                                                            }, [
                                                                                _createVNode(CheckBox, {
                                                                                    class: "checkbox",
                                                                                    checked: isCheckedItems(item.key),
                                                                                    blocked: handleSellerDayOffDimension(item.key),
                                                                                    disabled: shouldBlockKeyDimensionsByPreset(item.key) || handleSellerDayOffDimension(item.key)
                                                                                }, null, 8, ["checked", "blocked", "disabled"]),
                                                                                _createElementVNode("span", {
                                                                                    innerHTML: getHighlightText(item.name, searchMetric.value)
                                                                                }, null, 8, _hoisted_15)
                                                                            ], 10, _hoisted_14)
                                                                        ])
                                                                    ]),
                                                                    _: 2
                                                                }, 1032, ["content", "disabled"])
                                                            ]));
                                                        }), 128))
                                                    ])
                                                ]));
                                            }), 128))
                                        ]))
                                        : (_openBlock(), _createBlock(BaseLoader, {
                                            key: 1,
                                            id: "edit-columns-first"
                                        }))
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_16, [
                                _createElementVNode("h4", null, _toDisplayString(_ctx.$tc('dashboard.edit-columns.order')), 1),
                                _createElementVNode("div", _hoisted_17, [
                                    _createVNode(_Transition, { name: "fade" }, {
                                        default: _withCtx(() => [
                                            _createElementVNode("div", null, [
                                                _createElementVNode("h5", null, _toDisplayString(_ctx.$t('dashboard.edit-columns.selected-metrics-dimensions')), 1),
                                                _createElementVNode("div", _hoisted_18, [
                                                    (!getIsEditColumnsLoading.value)
                                                        ? (_openBlock(), _createBlock(_unref(draggable), {
                                                            key: 0,
                                                            onEnd: _cache[1] || (_cache[1] = ($event) => (onDrop('metrics')))
                                                        }, {
                                                            default: _withCtx(() => [
                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getMetricsAndDimensionsOrdering.value, (metric) => {
                                                                    return _withDirectives((_openBlock(), _createElementBlock("div", {
                                                                        key: metric.key,
                                                                        class: "selected"
                                                                    }, [
                                                                        _createElementVNode("div", {
                                                                            id: metric.key,
                                                                            class: "selected-title"
                                                                        }, [
                                                                            _hoisted_20,
                                                                            _createElementVNode("div", null, _toDisplayString(metric.name), 1)
                                                                        ], 8, _hoisted_19),
                                                                        (!shouldBlockKeyDimensionsByPreset(metric.key))
                                                                            ? (_openBlock(), _createElementBlock("i", {
                                                                                key: 0,
                                                                                class: "icon icon-trash",
                                                                                onClick: _withModifiers(($event) => (deleteCheckedMetricsAndDimensions(metric.key)), ["prevent"])
                                                                            }, null, 8, _hoisted_21))
                                                                            : _createCommentVNode("", true)
                                                                    ])), [
                                                                        [_vShow, getMetricsAndDimensionsOrdering.value.length]
                                                                    ]);
                                                                }), 128))
                                                            ]),
                                                            _: 1
                                                        }))
                                                        : (_openBlock(), _createBlock(BaseLoader, {
                                                            key: 1,
                                                            id: "edit-columns-second"
                                                        }))
                                                ])
                                            ])
                                        ]),
                                        _: 1
                                    })
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.$t('table-settings.text-remember-last-config')), 1),
                            _createElementVNode("div", _hoisted_24, [
                                _createElementVNode("button", {
                                    class: "btn btn-white",
                                    onClick: resetToDefault
                                }, _toDisplayString(_ctx.$t('table-settings.reset-table')), 1),
                                _createElementVNode("button", {
                                    class: "btn btn-submit",
                                    onClick: submit
                                }, _toDisplayString(_ctx.$t('table-settings.apply')), 1)
                            ])
                        ])
                    ])
                ]),
                _: 1
            }, 8, ["modelValue"]));
        };
    }
});
